import Decimal from 'decimal.js-light';

export default Decimal;

// https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
// returns a boolean if the value is Decimal
export function isDecimal(value: unknown): value is Decimal {
  return typeof value === 'object' && value !== null && 'decimalPlaces' in value;
}
